import React from "react";
import { ASSETS, CONTACT } from "@/data/content";
import { Container, Reveal } from "@/components/landing/shared";
import { scrollToId } from "@/lib/scroll";

export const Footer = () => {
  const year = new Date().getFullYear();
  const goTop = (e) => {
    e.preventDefault();
    scrollToId("overview", -120);
  };
  return (
    <footer className="bg-white hairline-top" data-testid="site-footer">
      <Container className="py-10 sm:py-14">
        <Reveal>
          <a href="#overview" onClick={goTop} aria-label="HR Anexi — back to top" data-testid="footer-logo-link" className="mx-auto block max-w-5xl">
            <img
              src={ASSETS.footerGraphic}
              alt="HR Anexi — 100+ consultants, strategic global alliances, satisfied customers across 60+ different industries. HR Anexi Wheel of Transformation, centered on ROI: Vision & Leadership Alignment, Organisation Structure, Organisation Culture, Competency Framework & Assessment, Performance Management, Leadership & Capability Building, Organisation Tools, Employee Engagement."
              className="h-auto w-full"
              loading="lazy"
              decoding="async"
              data-testid="footer-graphic"
            />
          </a>
        </Reveal>
      </Container>

      <div className="border-t border-[color:var(--hairline)]">
        <Container className="flex flex-col gap-3 py-5 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-[0.8rem] text-[#7A8794]">© {year} HR Anexi. All rights reserved.</p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <a href={`mailto:${CONTACT.email}`} className="text-[0.85rem] text-[color:var(--muted-ink)] transition-colors hover:text-[color:var(--ink)]" data-testid="footer-email-link">
              {CONTACT.email}
            </a>
            <a href={CONTACT.websiteUrl} target="_blank" rel="noopener noreferrer" className="text-[0.85rem] text-[color:var(--muted-ink)] transition-colors hover:text-[color:var(--ink)]" data-testid="footer-website-link">
              {CONTACT.website}
            </a>
          </div>
        </Container>
      </div>
    </footer>
  );
};
